
const initialState = {
    sidebarShow: true
  }
  
 export  const changeBarState = (state = initialState, type) => {
     
      return type;
  }